import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

/** Access = CEO, accountant, or user with explicit group finance grant. */
export function FinancePanelGuard() {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/auth/login" replace />;
  const allowed = user.is_ceo || user.role === "accountant" || user.has_group_finance_access;
  if (!allowed) return <Navigate to="/" replace />;
  return <Outlet />;
}
